// extracted by mini-css-extract-plugin
export default {"container":"About_container__EtY1t","wrap":"About_wrap__PqoAo"};